import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { CssLengthPopupComponent } from '@portal-core/ui/style-picker/components/css-length-popup/css-length-popup.component';

@NgModule({
  declarations: [
    CssLengthPopupComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    DropdownArrowModule
  ],
  exports: [
    CssLengthPopupComponent
  ]
})
export class CssLengthPopupModule { }